// src/services/apiClient.js
import axios from 'axios';

// Configuración base de axios
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 10000, // 10 segundos de timeout
});

// Interceptor para incluir el token de autenticación si existe
apiClient.interceptors.request.use(
  (config) => {
    // Priorizar sessionStorage sobre localStorage para consistencia
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      
    } else {
      console.warn('No se encontró token de autenticación');
    }
    
    // Debug adicional para admin routes
    if (config.url.includes('/admin/')) {
     
    }
    
    return config;
  },
  (error) => {
    console.error('Error en interceptor de request:', error);
    return Promise.reject(error);
  }
);

// Interceptor para manejar errores de respuesta
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // Manejo centralizado de errores
    const { response } = error;
    
    if (response) {
      console.error('Error de respuesta:', {
        status: response.status,
        data: response.data,
        url: error.config?.url
      });
      
      if (response.status === 401) {
        // Token inválido o expirado
        console.log('Token inválido o expirado, limpiando storage...');
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('user');
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        
        // Solo redirigir si no estamos ya en login
        if (!window.location.pathname.includes('/login') && window.location.pathname !== '/') {
          window.location.href = '/';
        }
      } else if (response.status === 403) {
        // Acceso denegado - problemas de permisos
        console.error('Acceso denegado:', response.data);
        alert(`Error de permisos: ${response.data.error || 'No tienes permisos suficientes'}`);
      }
    } else {
      console.error('Error de red o timeout:', error.message);
    }
    
    return Promise.reject(error);
  }
);

export default apiClient;